import { NgClass } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ICard } from '@interfaces/card-interface';

@Component({
  selector: 'aig-card',
  imports: [NgClass],
  templateUrl: './card.component.html',
  styleUrl: './card.component.scss'
})
export class CardComponent implements OnInit {
@Input() cardData! : ICard;
@Input() customClass: string = '';
@Output() buttonClicked = new EventEmitter<void>();

constructor() {}

  ngOnInit() {
  }

  onButtonClick() {
    this.buttonClicked.emit();
  }  
}
